import { Injectable } from '@angular/core';
import { toast } from 'ngx-sonner';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  success(message: string, config?: any) {
    toast.success(message, config);
  }

  error(message: string, config?: any) {
    toast.error(message, config);
  }

  warning(message: string, config?: any) {
    toast.warning(message, config);
  }

  info(message: string, config?: any) {
    toast.info(message, config);
  }

  loading(message: string, config?: any) {
    return toast.loading(message, config);
  }

  dismiss(toastId: string | number) {
    return toast.dismiss(toastId);
  }
}
